import { render, staticRenderFns } from "./icon-close-circle.vue?vue&type=template&id=53f2067e"
import script from "./icon-close-circle.vue?vue&type=script&setup=true&lang=ts"
export * from "./icon-close-circle.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports